/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IPromoBannerViewProps } from '@msdyn365-commerce-modules/promo-banner/src/modules/promo-banner/promo-banner';
import { IPromoBannerProps } from '../definition-extensions/promo-banner.ext.props.autogenerated';

const PromoBannerView: React.FC<IPromoBannerViewProps & IPromoBannerProps<{}>> = (props) => {
    const { promoBannerProps, contentProps, closeButton, bannerMessages, carouselProps } = props;

    const { fontColor, fontSize, boldText, italicizedText, underlineText } = props.config;

    const createConfigStyles = (isLink?: boolean): React.CSSProperties => {
        return {
            color: fontColor ? fontColor : '#FFFFFF',
            fontSize: fontSize ? `${fontSize}px` : '16px',
            fontWeight: boldText ? 'bold' : 'normal',
            fontStyle: italicizedText ? 'italic' : 'normal',
            textDecoration: underlineText || isLink ? 'underline' : 'none'
        };
    };

    const slides =
        bannerMessages &&
        bannerMessages.map((message, index) => {
            return (
                <Node {...contentProps} key={index}>
                    {message.text && (
                        <span className='ms-promo-banner__text' style={createConfigStyles()}>
                            {message.text}
                        </span>
                    )}
                    {message.links && message.links.length > 0 && (
                        <span className='ms-promo-banner__links'>
                            {message.links.map((link) => {
                                return (
                                    <a
                                        className='ms-promo-banner__link'
                                        role='button'
                                        title={link.linkText}
                                        href={link.linkUrl.destinationUrl}
                                        aria-label={link.ariaLabel}
                                        target={link.openInNewTab ? '_blank' : '_self'}
                                        style={createConfigStyles(true)}
                                    >
                                        {link.linkText}
                                    </a>
                                );
                            })}
                        </span>
                    )}
                </Node>
            );
        });

    return (
        <Module {...promoBannerProps}>
            <Node {...carouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
